import React from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { BookOpen, BookMarked, Clock } from "lucide-react";
import "../lms.css";

export default function StudentCourses() {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine active tab from URL path
  const isEnrolledTab = location.pathname.includes("enrolled-courses");
  const isRequestedTab = location.pathname.includes("requested-courses");
  const isPaymentHistoryTab = location.pathname.includes("payment-history");

  const activeTab = isRequestedTab
    ? "requested"
    : isEnrolledTab
    ? "enrolled"
    : "available";

  const handleTabChange = (tabKey) => {
    if (tabKey === "requested") {
      navigate("requested-courses");
    } else if (tabKey === "enrolled") {
      navigate("enrolled-courses");
    } else {
      navigate("available-courses");
    }
  };

  return (
    <div className="crs-root" style={{ padding: "8px 32px 24px 32px", maxWidth: "1400px", margin: "0 auto" }}>
      {/* Show 3 Course Tabs when not on Payment History */}
      {!isPaymentHistoryTab && (
        <div
          style={{
            display: "flex",
            gap: "12px",
            borderBottom: "2px solid #e2e8f0",
            marginBottom: "24px",
            flexWrap: "wrap",
          }}
        >
          <button
            type="button"
            onClick={() => handleTabChange("available")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "12px 20px",
              border: "none",
              background: "none",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              color: activeTab === "available" ? "#1c498d" : "#64748b",
              borderBottom: activeTab === "available" ? "3px solid #1c498d" : "3px solid transparent",
              marginBottom: "-2px",
              transition: "all 0.2s ease",
            }}
          >
            <BookOpen size={18} />
            Available Courses
          </button>

          <button
            type="button"
            onClick={() => handleTabChange("enrolled")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "12px 20px",
              border: "none",
              background: "none",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              color: activeTab === "enrolled" ? "#1c498d" : "#64748b",
              borderBottom: activeTab === "enrolled" ? "3px solid #1c498d" : "3px solid transparent",
              marginBottom: "-2px",
              transition: "all 0.2s ease",
            }}
          >
            <BookMarked size={18} />
            Enrolled Courses
          </button>

          <button
            type="button"
            onClick={() => handleTabChange("requested")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "12px 20px",
              border: "none",
              background: "none",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              color: activeTab === "requested" ? "#1c498d" : "#64748b",
              borderBottom: activeTab === "requested" ? "3px solid #1c498d" : "3px solid transparent",
              marginBottom: "-2px",
              transition: "all 0.2s ease",
            }}
          >
            <Clock size={18} />
            Requested Courses
          </button>
        </div>
      )}

      {/* Render Active Component via Outlet */}
      <Outlet />
    </div>
  );
}
